import api from './api';
import type { ReturnQueueItem, QcQueueItem, Asset, PaginatedResponse } from '@/types';

export interface ReturnStats {
  pendingReturns: number;
  overdueCount: number;
  qcPending: number;
  inRepair: number;
}

export interface ProcessReturnDto {
  rentalId: string;
  serialNumbers: string[];
  notes?: string;
}

export interface QcResultDto {
  serialNumber: string;
  passed: boolean;
  notes?: string;
}

export const returnsApi = {
  getPendingReturns: async (params: { page?: number; limit?: number } = {}) => {
    const response = await api.get<PaginatedResponse<ReturnQueueItem>>('/returns/pending', { params });
    return response.data;
  },

  getQcQueue: async (params: { page?: number; limit?: number } = {}) => {
    const response = await api.get<PaginatedResponse<QcQueueItem>>('/returns/qc/pending', { params });
    return response.data;
  },

  getRepairQueue: async (params: { page?: number; limit?: number } = {}) => {
    const response = await api.get<PaginatedResponse<Asset>>('/returns/repair/pending', { params });
    return response.data;
  },

  scan: async (value: string) => {
    const response = await api.get(`/returns/scan/${encodeURIComponent(value)}`);
    return response.data;
  },

  processReturn: async (dto: ProcessReturnDto) => {
    const response = await api.post('/returns/process', dto);
    return response.data;
  },

  processQc: async (dto: QcResultDto) => {
    const response = await api.post('/returns/qc/result', dto);
    return response.data;
  },

  processBatchQc: async (results: QcResultDto[]) => {
    const response = await api.post('/returns/qc/batch', { results });
    return response.data;
  },

  completeRental: async (rentalId: string) => {
    const response = await api.post(`/returns/rental/${rentalId}/complete`);
    return response.data;
  },

  getStats: async () => {
    const response = await api.get<ReturnStats>('/returns/stats');
    return response.data;
  },
};

export default returnsApi;
